import './tecdoc.less';

$(function () {
    if (document.getElementById('car-type')) {
        import('./type/type').then(function (module) {
            module.default;
        });
    }

    if (document.getElementById('car-model')) {
        import('./model/model').then(function (module) {
            module.default;
        });
    }

    if (document.getElementById('car-brand')) {
        import('./brand/brand').then(function (module) {
            module.default;
        });
    }

    if (document.getElementById('car')) {
        $('.price-filter .load').remove();
        import('./car/car').then(function (module) {
            module.default;
        });
    }

    if (document.getElementById('tecdoc-list')) {
        import('./tecdoc-list/tecdoc-list.js').then(function (module) {
            module.default;
        });
    }
});
